import React,{useRef} from 'react';
import { injectIntl } from 'react-intl';
import { adaptGameToContainer, getRemotedbUrl, i18nIntl, isNotEmpty } from '../../lib/ep.js';

import { useCanvasMachine } from '../../ts/games/canvasStateMachine.ts';
import FaceOffFinalCanvas from '../games/FaceOffFinalCanvas.js';
import FaceOffStats from './FaceOffStats.js';
import ShareGameFinal from './ShareGameFinal.js';
import LeveledHTMLText from './helpers/LeveledHTMLText.js';
import { uploadImage } from '../builder/ImageUploader.js';
import ActionLink from '../builder/ActionLink.js';
import { localizeFields } from '../builder/DynamicFields.js';

const PickFavoriteFinal = ({ stage, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const is_builder = props?.is_builder ?? false;

	const players = localizeFields((isNotEmpty(stage, 'faceoff_players')) ? stage.faceoff_players : [],props.locale);

	const user_answer = props?.user_answer ?? {};

	const share_enabled = stage?.share_enabled ?? true;
	const in_ranking = props?.in_ranking ?? false;
	const cnv = useRef(null);
	const uploaded = useRef(false);
	const winner_player_id = useRef(user_answer?.faceoff?.winner ?? players[0].id);
	const winner = useRef(players.find((p) => (p.id == winner_player_id.current)));

	const canvas_images =() => {
		const images = [];

		if(isNotEmpty(stage, 'full_game_final_bg_image')) {
			images.push({
				id:'final_bg_img',
				name:stage.game_final_bg_image,
				url:stage.full_game_final_bg_image,
				image:stage.full_game_final_bg_image,
				fit:'cover',
			});
		}

		let img = 'image';
		let count = 0;
		players.map((player) => {
			if(player.id == winner_player_id.current) {
				if(isNotEmpty(player, 'selected_image')) img = 'selected_image';

				images.push({
					id:'winner',
					name:player[img],
					url:player[`full_${img}`],
					image:player[`full_${img}`],
					fit:'contain',
					get_average_color:true,
				});

				return;
			}
			count++;
		});

		return images;
	};

	const download = () => {
		const image = cnv.current.to_image('base64');
		var a = document.createElement('a');
		a.href = image;
		a.download = "my_choice.jpg";
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}

	const [ state, dispatch ] = useCanvasMachine({
		images:canvas_images,
		images_dependencies:[stage.faceoff_players],
	});

	const display_stats = stage?.faceoff_display_stats ?? true;

	const main_description_placeholder = `<h1>${i18n("Results")}</h1>`;

	const final_message = (isNotEmpty(stage, 'final_message')) ? stage.final_message : main_description_placeholder;

	const generateShare = () => {
		if(is_builder) return;
		if(state.state != 'LOADED') return;
		if(uploaded.current) return;

		uploadImage(getRemotedbUrl(`/stages/upload/${stage.id}`), cnv.current.to_image(), (result) => {
			uploaded.current = true;
		}, { id:props.user_data.uid });
	};

	return (
		<div class={`game_final_state${(is_builder) ? ' in_buider' : ''}`}>
			{(final_message != " " && !in_ranking) && (
				<LeveledHTMLText>{final_message}</LeveledHTMLText>
			)}

			<div class="final_image">
				{(share_enabled) && (
					<FaceOffFinalCanvas
						ref={cnv}
						{...props}
						winner={winner.current}
						stage={stage}
						indexed_images={state.images}
						loaded_status={state.state}
						adaptToContainer={adaptGameToContainer}
						display_losers={false}
						locale={props.locale}
					/>
				)}

				{(share_enabled && !in_ranking) && (
					<div class="final_ctas">
						<ShareGameFinal
							stage={stage}
							locale={props.locale}
							onOpenLayer={generateShare}
							promotion={props?.promotion?.Promotion ?? (props?.promotion ?? {})}
							result={props.user_data}
							is_builder={is_builder}
							custom_cta_props={{
								cta_type:'link',
								//icon:'knk-share'
							}}
							intl={props.intl}
						/>

						<ActionLink
							onClick={download}
							//icon='knk-download'
						>Download</ActionLink>
					</div>
				)}
			
			</div>

			{(display_stats !== false && players.length > 0) && (
				<FaceOffStats
					stage={stage}
					players={players}
					stats={props?.stats ?? {}}
					max_items={parseInt(stage?.faceoff_stats_count ?? '3')}
					display_abs_stats={stage?.display_abs_stats ?? true}
					actual_selection={winner.current}
					is_builder={props.is_builder}
					intl={props.intl}
				/>
			)}
		</div>
	);
};

export default injectIntl(PickFavoriteFinal);